var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "popup-mailchimp-settings",
      attrs: { visible: _vm.showModal, size: "small" },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: _vm.closePopup
      },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("div", { staticClass: "dialog__header" }, [
                _c(
                  "div",
                  { staticClass: "dialog__header--title" },
                  [
                    _c("SaasIcon", {
                      attrs: { icon: "mailChimp", width: "56", height: "56" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-3" }, [
                      _c("span", { staticClass: "bold fs-5" }, [
                        _vm._v("Mailchimp")
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dialog__header--close" },
                  [
                    _c("CompassIconButton", {
                      attrs: { icon: "close" },
                      on: { click: _vm.closePopup }
                    })
                  ],
                  1
                )
              ])
            ]
          },
          proxy: true
        },
        {
          key: "default",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "dialog__default" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "mailchimpForm",
                      attrs: { model: _vm.mailchimpConfig, rules: _vm.rules }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$l10n.__(
                              "Connectez votre compte Mailchimp sur Sellsy."
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-divider"),
                      _vm._v(" "),
                      _vm.error
                        ? _c(
                            "div",
                            { staticClass: "alert alert-danger mb-3" },
                            [_vm._v(_vm._s(_vm.error))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "semibold mb-1 fs-4" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Installation")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-3" }, [
                        _c("span", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Connectez-vous à votre compte Mailchimp pour récupérer votre clé API-Account / Extra / API Keys - et entrez la ci-dessous."
                                )
                              ) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Pour en savoir plus vous pouvez consulter cette "
                                )
                              ) +
                              "\n\n                        "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "semibold pointer hover-primary-100",
                              attrs: {
                                target: "_blank",
                                href:
                                  "https://help.sellsy.com/hc/connecter-sellsy-avec-ses-outils/mailchimp"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$l10n.__("documentation")))]
                          ),
                          _vm._v(".\n                    ")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "apikey",
                            error: _vm.errors.get("apikey")
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "semibold mb-1 gray-100" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$l10n.__("Clé d'API")) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: { placeholder: "Renseigner" },
                            model: {
                              value: _vm.mailchimpConfig.apikey,
                              callback: function($$v) {
                                _vm.$set(_vm.mailchimpConfig, "apikey", $$v)
                              },
                              expression: "mailchimpConfig.apikey"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isConnected &&
                      (_vm.mode === "marketing" ||
                        _vm.mailchimpConfig.marketing.loaded) &&
                      !_vm.apiKeyChanged
                        ? _c(
                            "div",
                            { staticClass: "flex-column marketing mt-3" },
                            [
                              _c(
                                "span",
                                { staticClass: "semibold fs-4 mb-1" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Audience pour les campagnes emailing"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "mb-3" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Vous pouvez sélectionner l’audience par défaut pour vos campagnes emailing."
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "marketing" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function() {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "semibold mb-1 gray-100"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$l10n.__(
                                                        "Liste par défaut"
                                                      )
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3569972281
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("select-input", {
                                    attrs: {
                                      appendToBody: true,
                                      mode: "edit",
                                      labelColumn: "name",
                                      idColumn: "id",
                                      selectNothing: _vm.$t.__(
                                        "common.labels.none"
                                      ),
                                      options: _vm.mailchimpConfig.audiences,
                                      placeholder: _vm.$t.__(
                                        "common.actions.select_default_list"
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.mailchimpConfig.marketing
                                          .audience_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mailchimpConfig.marketing,
                                          "audience_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mailchimpConfig.marketing.audience_id"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mode === "settings"
                        ? _c(
                            "div",
                            { staticClass: "flex-column synchro-contact" },
                            [
                              _c(
                                "span",
                                { staticClass: "semibold fs-4 mb-1" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Synchroniser les contacts"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isConnected && !_vm.apiKeyChanged
                                ? _c(
                                    "div",
                                    { staticClass: "flex-column" },
                                    [
                                      _c("span", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Vous pouvez synchroniser vos contacts Sellsy sur votre compte Mailchimp."
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { prop: "mcp_defaultList" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "semibold mb-1 gray-100"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                    " +
                                                            _vm._s(
                                                              _vm.$l10n.__(
                                                                "Liste par défaut"
                                                              )
                                                            ) +
                                                            "\n                                "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            1387529273
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("select-input", {
                                            attrs: {
                                              mode: "edit",
                                              labelColumn: "name",
                                              appendToBody: true,
                                              idColumn: "id",
                                              selectNothing: _vm.$t.__(
                                                "common.labels.none"
                                              ),
                                              options:
                                                _vm.mailchimpConfig.audiences,
                                              placeholder: _vm.$t.__(
                                                "common.actions.select_default_list"
                                              )
                                            },
                                            model: {
                                              value:
                                                _vm.mailchimpConfig
                                                  .contacts_synchronization
                                                  .audience_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mailchimpConfig
                                                    .contacts_synchronization,
                                                  "audience_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mailchimpConfig.contacts_synchronization.audience_id"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.audienceIdContactChanged
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "semibold mb-1 gray-100"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$l10n.__(
                                                          "Valeurs par défaut"
                                                        )
                                                      ) +
                                                      "\n                            "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.mailchimpConfig
                                                  .contacts_synchronization
                                                  .merge_fields,
                                                function(mergeField, index) {
                                                  return _c(
                                                    "el-form-item",
                                                    { key: index },
                                                    [
                                                      mergeField.type ===
                                                      "dropdown"
                                                        ? _c("select-input", {
                                                            attrs: {
                                                              mode: "edit",
                                                              labelColumn:
                                                                "label",
                                                              idColumn: "label",
                                                              options:
                                                                mergeField.choices,
                                                              appendToBody: true,
                                                              placeholder:
                                                                mergeField.tag
                                                            },
                                                            model: {
                                                              value:
                                                                mergeField.default_value,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  mergeField,
                                                                  "default_value",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "mergeField.default_value"
                                                            }
                                                          })
                                                        : _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                mergeField.tag
                                                            },
                                                            model: {
                                                              value:
                                                                mergeField.default_value,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  mergeField,
                                                                  "default_value",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "mergeField.default_value"
                                                            }
                                                          })
                                                    ],
                                                    1
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("CompassButton", {
                                            staticClass: "mb-2",
                                            attrs: {
                                              label: _vm.$t.__(
                                                "popups.PopupMailchimpSettings.synchronize_contact"
                                              ),
                                              type: "tertiary"
                                            },
                                            on: { click: _vm.onSyncroContact }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "mb-3" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "L’action suivante va vous permettre d’activer la synchronisation Mailchimp pour les contacts de vos clients/prospects/fournisseurs en un seul clic."
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "syncroEnabled" } },
                                [
                                  _c("radio-input", {
                                    attrs: {
                                      mode: "edit",
                                      choices: _vm.choicesSyncro
                                    },
                                    model: {
                                      value:
                                        _vm.mailchimpConfig
                                          .contacts_synchronization.enabled,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mailchimpConfig
                                            .contacts_synchronization,
                                          "enabled",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mailchimpConfig.contacts_synchronization.enabled"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "mcp_syncroTypeContact" } },
                                [
                                  _c("select-input", {
                                    attrs: {
                                      mode: "edit",
                                      appendToBody: true,
                                      options: _vm.filter
                                    },
                                    model: {
                                      value:
                                        _vm.mailchimpConfig
                                          .contacts_synchronization.filter,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mailchimpConfig
                                            .contacts_synchronization,
                                          "filter",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mailchimpConfig.contacts_synchronization.filter"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("CompassButton", {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "popups.PopupMailchimpSettings.update_contact"
                                      ),
                                      type: "tertiary"
                                    },
                                    on: { click: _vm.onUpdateContact }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        },
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "dialog__footer" },
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.cancel"),
                      type: "secondary"
                    },
                    on: { click: _vm.closePopup }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    staticClass: "ml-2",
                    attrs: {
                      label: _vm.$t.__("common.actions.save"),
                      type: "primary",
                      loading: _vm.isFormSubmitted
                    },
                    on: { click: _vm.onSubmitForm }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c("preloader", { attrs: { display: _vm.loading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }